import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_4, SPACING_5 } from 'constants/theme-constants';
import styled from 'styled-components';

export const SiteAndDatePickerWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom:  ${cxTheme.spacing[SPACING_5]};
  `}
`;

export const SummaryCardWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    gap: ${cxTheme.spacing[7]};
    margin-bottom: ${cxTheme.spacing[7]};


    @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
      align-items: center;
      flex-direction: column;
      justify-content: center;
      position: relative;
      width: 100%;
    }

    .cardWrapper {
      display: flex;
      flex: 1 1 276px;
    }
  `}
`;

export const ChipsWrapper = styled.div`
  ${({ theme }) => `
    margin-bottom: ${cxTheme.spacing[SPACING_5]};
  `}
`;
export const SummaryCardContainer = styled.div`
  ${({ theme }) => `
     display: flex;
     flex-direction: column;
     align-items: center;
     align-self: center;
     z-index: 3;
     position: relative;
     width: 90vw;

     @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
      z-index: 1;
    }
  `}
`;

export const OperationsSummaryCardWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    gap: ${cxTheme.spacing[SPACING_4]};
    margin-bottom: ${cxTheme.spacing[SPACING_4]};


    @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
      align-items: center;
      flex-flow: column wrap;
      justify-content: center;
      position: relative;
      width: 100%;
    }

    .cardWrapper {
      display: flex;
      flex: 1 1 276px;
    }
  `}
`;

export const OperationsSummaryCardContainer = styled.div`
  ${({ theme }) => `
     display: flex;
     flex-direction: row;
     align-items: center;
     align-self: center;
     z-index: ${cxTheme.zIndex[5]};
     position: relative;
     width: 90%;
  `}
`;

export const AlertContainer = styled.div`
  min-height: 48px;
  background: ${({ theme }) => theme.system.subtle.warning};
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 8px 4px 16px;
`;
